export default "__VITE_ASSET__ac98yds5__"